var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconawesomeeye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.518,
    height: 11.679,
    viewBox: "0 0 17.518 11.679",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-eye",
    "data-name": "Icon awesome-eye",
    d: "M17.412,9.9A9.755,9.755,0,0,0,8.759,4.5,9.756,9.756,0,0,0,.106,9.9a.984.984,0,0,0,0,.888,9.755,9.755,0,0,0,8.653,5.4,9.756,9.756,0,0,0,8.653-5.4A.984.984,0,0,0,17.412,9.9ZM8.759,14.719a4.379,4.379,0,1,1,4.379-4.379A4.379,4.379,0,0,1,8.759,14.719Zm0-7.3a2.9,2.9,0,0,0-.77.115A1.455,1.455,0,0,1,5.955,9.57a2.913,2.913,0,1,0,2.8-2.15Z",
    transform: "translate(0 -4.5)",
    fill: "#1b3e6f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeeye);
export default __webpack_public_path__ + "static/media/Iconawesomeeye.f6904d11a7157e3abf9f82577d467b7a.svg";
export { ForwardRef as ReactComponent };